import { useQuery } from "@tanstack/react-query";
import {
  type GetCurrentMonthlyPoolTotalQueryResult,
  type LoyaltyPointType,
  type Region,
  getSettlementPoolBoostsPoolTotalRegionLoyaltyPointType,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const POOL_TOTAL_QUERY_KEY = "POOL_TOTAL";

export const poolTotalKeys = {
  all: [POOL_TOTAL_QUERY_KEY] as const,
  byRegionAndType: (region: Region, loyaltyPointType: LoyaltyPointType) =>
    [...poolTotalKeys.all, region, loyaltyPointType] as const,
};

export const useGetPoolTotalQuery = (
  region: Region,
  loyaltyPointType: LoyaltyPointType,
) =>
  useQuery<GetCurrentMonthlyPoolTotalQueryResult>({
    queryKey: poolTotalKeys.byRegionAndType(region, loyaltyPointType),
    queryFn: processResponseWithApiProblemDetails(() =>
      getSettlementPoolBoostsPoolTotalRegionLoyaltyPointType(
        region,
        loyaltyPointType,
      ),
    ),
    refetchOnWindowFocus: false,
  });
